module.exports = __webpack_public_path__ + "img/885-7aa3da.png";